export const ITEM_DIETARY_FIELDS = ["isVegetarian", "isOrganic", "isLocal"]

export const ITEM_ALLERGEN_FIELDS = [
  "allergenArachide",
  "allergenCeleri",
  "allergenCrustaces",
  "allergenGluten",
  "allergenFruitsANoque",
  "allergenLait",
  "allergenLupin",
  "allergenOeuf",
  "allergenPoisson",
  "allergenMollusques",
  "allergenMoutarde",
  "allergenSesame",
  "allergenSoja",
  "allergenSulfites",
]

export const ITEM_AVAILABILITY_DEFAULTS = {
  isAvailable24_7: false,
  commandable: true,
  isActive: true,
}

export const DIETARY_LABELS_FR = {
  isVegetarian: "Végétarien",
  isOrganic: "Bio",
  isLocal: "Local",
}

export const ALLERGEN_ICONS = {
  allergenArachide: "🥜",
  allergenCeleri: "🥬",
  allergenCrustaces: "🦐",
  allergenGluten: "🌾",
  allergenFruitsANoque: "🌰",
  allergenLait: "🥛",
  allergenLupin: "🌼",
  allergenOeuf: "🥚",
  allergenPoisson: "🐟",
  allergenMollusques: "🦪",
  allergenMoutarde: "🟡",
  allergenSesame: "⚪",
  allergenSoja: "🫘",
  allergenSulfites: "🍷",
}

export const ALLERGEN_LABELS_FR = {
  allergenArachide: "Arachides",
  allergenCeleri: "Céleri",
  allergenCrustaces: "Crustacés",
  allergenGluten: "Gluten",
  allergenFruitsANoque: "Fruits à coque",
  allergenLait: "Lait",
  allergenLupin: "Lupin",
  allergenOeuf: "Œuf",
  allergenPoisson: "Poisson",
  allergenMollusques: "Mollusques",
  allergenMoutarde: "Moutarde",
  allergenSesame: "Sésame",
  allergenSoja: "Soja",
  allergenSulfites: "Sulfites",
}

export const AVAILABILITY_LABELS_FR = {
  isActive: "Disponible",
  commandable: "Commandable",
  isAvailable24_7: "Disponible 24h/24",
}

export const ALLERGEN_CLIENT_TRANSLATIONS = {
  fr: ALLERGEN_LABELS_FR,
  en: {
    allergenArachide: "Peanuts",
    allergenCeleri: "Celery",
    allergenCrustaces: "Crustaceans",
    allergenGluten: "Gluten",
    allergenFruitsANoque: "Tree nuts",
    allergenLait: "Milk",
    allergenLupin: "Lupin",
    allergenOeuf: "Egg",
    allergenPoisson: "Fish",
    allergenMollusques: "Molluscs",
    allergenMoutarde: "Mustard",
    allergenSesame: "Sesame",
    allergenSoja: "Soy",
    allergenSulfites: "Sulphites",
  },
  ar: {
    allergenArachide: "فول سوداني",
    allergenCeleri: "كرفس",
    allergenCrustaces: "قشريات",
    allergenGluten: "جلوتين",
    allergenFruitsANoque: "مكسرات",
    allergenLait: "حليب",
    allergenLupin: "ترمس",
    allergenOeuf: "بيض",
    allergenPoisson: "سمك",
    allergenMollusques: "رخويات",
    allergenMoutarde: "خردل",
    allergenSesame: "سمسم",
    allergenSoja: "صويا",
    allergenSulfites: "كبريتات",
  },
}
